const getTime = (timeString) => {
    let time = new Date(timeString);
    let months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    let date = `${time.getDate() < 10 ? "0" : ""}${time.getDate()}`;
    let hours = `${time.getHours() < 10 ? "0" : ""}${time.getHours()}`;
    let minutes = `${time.getMinutes() < 10 ? "0" : ""}${time.getMinutes()}`;
    let seconds = `${time.getSeconds() < 10 ? "0" : ""}${time.getSeconds()}`;
    return `${date} ${
        months[time.getMonth()]
    }, ${time.getFullYear()} at ${hours}:${minutes}:${seconds}`;
};

export default getTime;
